// Vendor libraries
import { ElementRef, NgZone } from '@angular/core';
// Services
import { AIStreamingService } from 'NewAngular/services/ai-streaming.service';
import { NEWS_AI_GENERIC_ERROR_MESSAGE } from 'NewsApp/constants';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/ai-streaming.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "SecuritiesApp/ts/features/news-ai-chat/news-ai-answer-source.component";
const _c0 = a0 => ({ "show": a0 });
function NewsAIResponseComponent_div_4_tr_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 11);
} if (rf & 2) {
    const source_r3 = ctx.$implicit;
    i0.ɵɵproperty("source", source_r3);
} }
function NewsAIResponseComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function NewsAIResponseComponent_div_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.showSources = !ctx_r1.showSources); });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "News Sources");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 7)(5, "table", 8)(6, "thead")(7, "tr")(8, "td", 9);
    i0.ɵɵtext(9, "Time (ET)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 9);
    i0.ɵɵtext(11, "Symbol");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 9);
    i0.ɵɵtext(13, "Headline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 9);
    i0.ɵɵtext(15, "Wire");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(16, "tbody");
    i0.ɵɵtemplate(17, NewsAIResponseComponent_div_4_tr_17_Template, 1, 1, "tr", 10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r1.showSources));
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngForOf", ctx_r1.chatMessage.sources);
} }
/**
 * News AI Response
 *
 * Streams and Displays the AI response to a query.
 *
 * Input Properties:
 *  chatMessage: NewsChatMessage representing the AI response
 */
export class NewsAIResponseComponent {
    constructor(aiStreamingService, el, ngZone) {
        this.aiStreamingService = aiStreamingService;
        this.el = el;
        this.ngZone = ngZone;
        this.loadingResponse = false;
        this.showSources = false;
        this.getAIResponse = (query) => {
            this.loadingResponse = true;
            this.chatMessage.message = 'Generating response&nbsp;<span class="loader-dots">';
            let first = true;
            const url = `news?query=${encodeURIComponent(query)}&securityId=${this.chatMessage.security_id || ''}`;
            const handlers = {
                token: async (token) => {
                    if (first) {
                        this.chatMessage.message = '';
                        first = false;
                    }
                    this.ngZone.run(() => {
                        this.chatMessage.message += `<span>${token}</span>`;
                    });
                    this.scrollResponseIntoView();
                },
                error: () => {
                    this.ngZone.run(() => {
                        this.chatMessage.message = `<span>${NEWS_AI_GENERIC_ERROR_MESSAGE}</span>`;
                        this.loadingResponse = false;
                    });
                    this.scrollResponseIntoView();
                },
                done: () => {
                    this.ngZone.run(() => {
                        this.loadingResponse = false;
                    });
                    this.scrollResponseIntoView();
                },
            };
            const customHandlers = {
                sources: (event) => {
                    this.ngZone.run(() => {
                        this.chatMessage.sources = JSON.parse(event.data);
                    });
                },
            };
            this.aiStreamingService.stream(url, handlers, customHandlers);
        };
    }
    ngOnInit() {
        if (this.chatMessage.query) {
            this.getAIResponse(this.chatMessage.query);
        }
    }
    scrollResponseIntoView() {
        const scrollContainer = document.querySelector('ycn-news-ai-chat');
        const containerHeight = scrollContainer.clientHeight;
        if (this.el.nativeElement.offsetTop + this.el.nativeElement.offsetHeight >
            scrollContainer.scrollTop + containerHeight) {
            scrollContainer.scrollTop =
                this.el.nativeElement.offsetTop + this.el.nativeElement.offsetHeight - containerHeight;
        }
    }
}
NewsAIResponseComponent.ɵfac = function NewsAIResponseComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewsAIResponseComponent)(i0.ɵɵdirectiveInject(i1.AIStreamingService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone)); };
NewsAIResponseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NewsAIResponseComponent, selectors: [["ycn-news-ai-response"]], hostVars: 2, hostBindings: function NewsAIResponseComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("is-loading", ctx.loadingResponse);
    } }, inputs: { chatMessage: "chatMessage" }, standalone: false, decls: 5, vars: 3, consts: [[1, "ai-module-icon"], ["ycnIcon", "", "role", "img", 3, "name"], [1, "ai-module-content"], [3, "innerHTML"], ["class", "border-t border-color-gray-90 pt-20", "data-test-id", "news-ai-sources", 4, "ngIf"], ["data-test-id", "news-ai-sources", 1, "border-t", "border-color-gray-90", "pt-20"], [1, "btn", "btn-transparent2", "collapse-toggler", "mb-1", 3, "click"], [1, "collapse", 3, "ngClass"], [1, "table", "border-0", "mb-row"], [1, "text-thin"], ["ycn-news-ai-answer-source", "", 3, "source", 4, "ngFor", "ngForOf"], ["ycn-news-ai-answer-source", "", 3, "source"]], template: function NewsAIResponseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(1, "svg", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "p", 3);
        i0.ɵɵtemplate(4, NewsAIResponseComponent_div_4_Template, 18, 4, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-ai-a");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", ctx.chatMessage.message, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.chatMessage.sources == null ? null : ctx.chatMessage.sources.length);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.IconDirective, i4.NewsAIAnswerSourceComponent], encapsulation: 2 });
